import { state_ctrl_factory_method } from 'ww2_analytics/common/state_ctrl';

const main_view = {
    template: require('./view.html'),
    controller: state_ctrl_factory_method('retention.by_mission', function($scope, resp) {
        $scope.rows = resp;
    }),
};
const state_config = {
    url: '/by_mission',
    reloadOnSearch: false,
    data: {
        priority: 898,
        title: 'By Mission',
    },
    views: {
        '': main_view,
        'main-filter@amt.ww2': require('ww2_analytics/segments/missions_form'),
    },
};
export default state_config;
